/* eslint-disable */
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { parseQueryString } from '@/utils/helpers'
//封装新的withRouter高阶函数
export function WithRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation()
    let navigate = useNavigate()
    let params = useParams()
    return (
      <Component
        {...props}
        location={{
          ...location,
          search: parseQueryString(location.search)
        }}
        navigate={navigate}
        params={params}
      />
    )
  }
  return ComponentWithRouterProp
}
